import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';

import useStylesGridItem from './useStylesGridItem';

export const spacingOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9];
export const gridColumns = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const GridItem = ({
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  noGutters,
  xsOrder,
  smOrder,
  mdOrder,
  lgOrder,
  xlOrder,
  ...rest
}) => {
  const theme = useTheme();
  const { wrenchGridItem } = useStylesGridItem({
    xs,
    sm,
    md,
    lg,
    xl,
    noGutters,
    xsOrder,
    smOrder,
    mdOrder,
    lgOrder,
    xlOrder,
    theme,
  });

  return (
    <div className={wrenchGridItem} {...safeRest(rest)}>
      {children}
    </div>
  );
};

GridItem.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Amount of space items take up at xs breakpoint and above.
   */
  xs: PropTypes.oneOf(gridColumns),
  /**
   * Amount of space items take up at sm breakpoint and above.
   */
  sm: PropTypes.oneOf(gridColumns),
  /**
   * Amount of space items take up at md breakpoint and above.
   */
  md: PropTypes.oneOf(gridColumns),
  /**
   * Amount of space items take up at lg breakpoint and above.
   */
  lg: PropTypes.oneOf(gridColumns),
  /**
   * Amount of space items take up at xl breakpoint and above.
   */
  xl: PropTypes.oneOf(gridColumns),
  /**
   * No gutters flag
   */
  noGutters: PropTypes.bool,
  /**
   * Order of item at xs breakpoint and above.
   */
  xsOrder: PropTypes.number,
  /**
   * Order of item at sm breakpoint and above.
   */
  smOrder: PropTypes.number,
  /**
   * Order of item at md breakpoint and above.
   */
  mdOrder: PropTypes.number,
  /**
   * Order of item at lg breakpoint and above.
   */
  lgOrder: PropTypes.number,
  /**
   * Order of item at xl breakpoint and above.
   */
  xlOrder: PropTypes.number,
};

GridItem.defaultProps = {
  xs: undefined,
  sm: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined,
  noGutters: undefined,
  xsOrder: undefined,
  smOrder: undefined,
  mdOrder: undefined,
  lgOrder: undefined,
  xlOrder: undefined,
};

export default GridItem;
